<template>
  <TagSelector
    :multiple="multiple"
    :items="users"
    :value="value"
    @input="$emit('input', $event)"
    itemText="full_name"
    itemValue="id"
  />
</template>

<script>
export default {
  props: {
    value: [String, Number, Array],
    multiple: Boolean,
  },
  data() {
    return {
      users: [],
    };
  },
  created() {
    this.setUsers();
  },
  methods: {
    async setUsers() {
      const { data } = await this.$api.User.lite();
      this.users = data;
    },
  },
};
</script>

<style></style>
